import React from "react";
import images from "../../constant/images";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");
  return (
    <div
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
      className="flex flex-col text-white items-center min-h-screen justify-center "
    >
      {" "}
      <div className="text-9xl font-bold">404</div>
      <div className="text-2xl font-semibold">
        {language === "fr" ? "Page Introvable" : "Page Not Found"}
      </div>
    </div>
  );
}
